import { render, staticRenderFns } from "./Electricity.vue?vue&type=template&id=c8a1bfac&scoped=true&"
import script from "./Electricity.vue?vue&type=script&lang=js&"
export * from "./Electricity.vue?vue&type=script&lang=js&"
import style0 from "./Electricity.vue?vue&type=style&index=0&id=c8a1bfac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a1bfac",
  null
  
)

export default component.exports